import type { Nullable } from '@axinom/mosaic-ui';
import type {
  CreateServiceDeploymentMutation,
  CreateServiceDeploymentMutationVariables,
  CustomizableServiceDeploymentsQuery,
  Maybe,
  ServiceDeploymentDetailsQuery,
  ServiceDeploymentManifest,
  ServiceDeploymentManifestCondition,
  ServicePiletArtifactCondition,
} from '../../../../generated/hosting-service';
import type { ContainerImage } from './RowSelectField/RowExplorer.types';

export type SubmitResponse =
  | CreateServiceDeploymentMutation['initiateServiceDeployment']
  | undefined;

export type ServiceDeploymentFormData = Nullable<
  CreateServiceDeploymentMutationVariables['input']
>;

export interface RowDataFieldProps {
  name: string;
}

export interface LoadDataType {
  name: string;
  containerImage: [ContainerImage] | [];
  serviceDeploymentManifest: [ServiceDeploymentManifestCondition] | [];
  servicePiletArtifacts: [ServicePiletArtifactCondition | undefined] | [];
}

export type DeploymentService = NonNullable<
  ServiceDeploymentDetailsQuery['serviceDeployment']
>;

export interface DeploymentDetails
  extends Omit<
    DeploymentService,
    'serviceDeploymentManifest' | 'servicePiletArtifacts'
  > {
  containerImage: [{ id: number; containerImageVersion: string }];
  serviceDeploymentManifest: [
    | Maybe<
        { __typename?: 'ServiceDeploymentManifest' | undefined } & Pick<
          ServiceDeploymentManifest,
          'name' | 'createdDate'
        >
      >
    | undefined,
  ];
  servicePiletArtifacts?: NonNullable<
    DeploymentService['serviceDefinition']
  >['servicePiletArtifacts']['nodes'];
}

export type CustomizableServiceDeploymentData = NonNullable<
  CustomizableServiceDeploymentsQuery['filtered']
>['nodes'][number];

// TODO: Maybe usages of this can be somehow reworked to reuse the `ResourceStatus` enum?
export const DeploymentStatusConstants: Record<string, string> = {
  // Deployment Status Types
  CREATE_PENDING: 'Deploying',
  DELETE_PENDING: 'Undeploying',
  READY: 'Deployed',
  CREATE_ERROR: 'Error Deploying',
  DELETE_ERROR: 'Error Undeploying',
  DELETE_COMPLETED: 'Not Deployed',
  SCALED_DOWN: 'Scaled Down',
};
